module.exports = __webpack_public_path__ + "img/543.0e8365d0.jpg";